
export const utmActions = {
  SET_UTM_PARAMS: 'SET_UTM_PARAMS',
  SET_INITIAL_DATA:'SET_INITIAL_DATA'
};
